import { render, staticRenderFns } from "./WorldBrands.vue?vue&type=template&id=3623e545"
import script from "./WorldBrands.vue?vue&type=script&lang=js"
export * from "./WorldBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports